import { combineReducers } from 'redux';
import shareReducer from '../shared_elements/reducers';

const rootReducer = combineReducers({
  shareReducer,
});
export default rootReducer;
